import { render, staticRenderFns } from "./FAvatarMenuItem.vue?vue&type=template&id=77d581f4&"
import script from "./FAvatarMenuItem.vue?vue&type=script&lang=js&"
export * from "./FAvatarMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports